<template>
    <div class="wrap">
        <div class="title">{{ title }}</div>
        <div class="filters">
            <div class="user" v-show="isAdmin">
                <vue-select
                    placeholder="User"
                    :options="userOptions"
                    v-model="filters.userId"
                />
            </div>
            <div class="date-picker">
                <v-text-field
                    :value="getStartDate(filters.startDate)"
                    label="Start Date"
                    prepend-icon="event"
                    readonly
                    @click="startModal = true"
                ></v-text-field>
            </div>
            <div class="date-picker">
                <v-text-field
                    :value="endDate(filters.endDate)"
                    label="End Date"
                    prepend-icon="event"
                    readonly
                    @click="endModal = true"
                ></v-text-field>
            </div>
            <div class="status">
                <vue-select
                    :options="statuses"
                    v-model="filters.status"
                    placeholder="Status"
                />
            </div>
            <Button
                label="Submit"
                color="primary"
                cssClass="ml-3 mt-2"
                @click="handleSubmit"
            />
        </div>
            <v-dialog
                ref="startDialog"
                v-model="startModal"
                :return-value.sync="filters.startDate"
                persistent
                width="290px"
            >
                <v-date-picker v-model="filters.startDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelModal('startDate')">Cancel</v-btn>
                <v-btn text color="primary" @click="() => {
                    $refs.startDialog.save(filters.startDate);
                    this.startModal = false;
                }">OK</v-btn>
                </v-date-picker>
            </v-dialog>
            <v-dialog
                ref="dialog"
                v-model="endModal"
                :return-value.sync="filters.endDate"
                persistent
                width="290px"
            >
                <template v-slot:activator="{ on }">
                    
                </template>
                <v-date-picker v-model="filters.endDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelModal('endDate')">Cancel</v-btn>
                <v-btn text color="primary" @click="() => {
                    $refs.dialog.save(filters.endDate);
                    this.endModal = false;
                }">OK</v-btn>
                </v-date-picker>
            </v-dialog>
        <div style="margin: 40px">
            <v-data-table
                :items="items"
                :headers="columns"
                :loading="loading"
            />
        </div>
    </div>
</template>

<script>

import { listUsers as listUserService } from '../../services/user';
import vueSelect from 'vue-select';
import Button from '../../components/Elements/Button'
import { extractError } from '../../utils/error';
import {
    paymentColumns,
    addColumns
} from './config';
import {
    mapGetters
} from 'vuex';

export default {
    components: {
        vueSelect,
        Button
    },
    data() {
        return {
            loading: false,
            items: [],
            startModal: '',
            endModal: '',
            statuses: [
                {
                    label: 'Success',
                    value: 'SUCCESS'
                },
                {
                    label: 'Failure',
                    value: 'FAILED'
                }
            ],
            filters: {
                userId: null,
                startDate: null,
                endDate: null,
                status: null,
            },
            users: [],
        }
    },
    props: {
        remoteService: Function,
        context: String,
    },
    computed: {
        ...mapGetters('auth', ['isAdmin', 'userId']),
        userOptions() {
            return this.users.map(u => ({
                label: u.email + ' ' + u.mobile,
                code: u._links.self.href
            }))
        },
        filterBy() {
            let {
                userId,
                startDate,
                endDate,
                status
            } = this.filters;
            if(!this.isAdmin) {
                userId = this.userId;
            }
            if(userId) {
                if(startDate && endDate){
                    if(!(status && status.value))
                        return 2;
                    return 3;
                }
                if(status && status.value)
                    return 4;
                return 1;
            }
            // user id is null
            else {
                if(!status && startDate && endDate) {
                    return 5;
                }
                if(status && !startDate && !endDate) {
                    return 7;
                }
                return 6;
            }
        },
        columns() {
            const options = {
                excludeUser: !this.isAdmin
            }
            if(this.context === 'payments') {
                return paymentColumns(options);
            }
            if(this.context === 'add') {
                return addColumns(options);
            }
            return addColumns(options);
        },
        title() {
            const { context } = this;
            if(context === 'add')
                return 'Activation Report'
            if(context === 'renew')
                return 'Renewal Report'
            if(context === 'payments')
                return 'Topup Report'
            return 'Topup Report'
        }
    },
    methods: {
        endDate(date) {
         if (!date) {
          let d = new Date();
        return d.toLocaleString('en-GB').split(',')[0];
      } else {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
        },

    getStartDate(date) {
      if (!date) {
          let d = new Date();
          d.setDate(1);
        return d.toLocaleString('en-GB').split(',')[0];
      } else {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
    },
        cancelModal(which) {
            this.startModal = false;
            this.endModal = false;
            this.filters[which] = '';
        },
        async handleSubmit() {
            try {
                this.loading = true;
                this.items = [];
                const remoteService = this.remoteService;
                const payload = { ...this.filters };
                payload.filterBy = this.filterBy;
                if (payload.userId) {
                    const group = payload.userId.code.match(/users.*(\d)+$/);
                    const userId = group[1];
                    payload.userId = userId;
                }
                if (payload.status)
                    payload.status = payload.status.value;
                if (!this.isAdmin) {
                    payload.userId = this.userId;
                }
                // console.log('final payload : ', JSON.parse(JSON.stringify(payload)));
                const result = Object.freeze(await remoteService(payload));
                console.log('got response : ', result);
                this.items = result.map(r => ({
                    ...r,
                    userName: r.user.userInfo.firstname + ' ' + r.user.userInfo.lastname
                }));
                this.loading = false;
            }
            catch(err) {
                console.log(err);
                this.loading = false;
                const message = extractError(err);
                this.$showError(message);
            }
        }
    },
    watch: {
        context: function() {
            this.items = [];
            this.filters.userId = null;
            this.filters.status = null;
        }
    },
    async mounted() {
        console.log('report mounted');
        try {
            const users = await listUserService();
            console.log('got users : ', users);
            this.users = users;

        }
        catch(err) {
            console.log(err);
        }
    }
}
</script>

<style lang="scss" scoped>
    .wrap {
        margin-top: 50px;
    }
    .title {
        margin-left: 40px;
    }
    .filters {
        display: flex;
        margin: 0 20px 0 20px;

        .user {
            margin: 12px 20px;
            transition: all 0.3s ease;
            width: 400px;
        }
    }
    .date-picker {
        width: 250px;
    }
    .status {
        width: 150px;
        margin: 15px 5px 0 15px;
    }
    .status ul {
        padding: 0 !important;
    }
</style>
<style>
    ul {
        padding: 0 !important;
    }
</style>